(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsEffectivinessController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'LangService', 'NotificationFactory'];

  function reports ($scope, $http, $timeout, ngTableParams, LangService, NotificationFactory) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'menu.reports.effect' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
        vm.types = [
          {
            'id': 'operator',
            'name': vm.labels.operator
          },
          {
            'id': 'sector',
            'name': vm.labels.sector
          }
        ];
        vm.current_type = vm.types[0];
        reload();
      });

    	$scope.vm = vm;
    Chart.defaults.global.legend.display = true;
    vm.loading = true;

    vm.changeType = function (type) {
      vm.current_type = type;
      reload();
    }

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.table = new ngTableParams({
      page: 1,
      total: 50
    }, {
      getData: function ($defer, params) {
        params.total(gdata.total);
        $defer.resolve(gdata.result);
      }
    });

    var gdata = {};
    function reload () {
      vm.loading = true;
      gdata = {};
      $http.get(apiUrl + '/reports/effectiviness', {
        // params: params.url()
        params: {
          type: vm.current_type.id,
          filters: vm.filters
        }
      })
        .then(function ({ data }) {
          // params.total(data.total);
          // $defer.resolve(data.result);
          if (data.success === false) {
            notifSet.addNotification({
              title: 'Erro!',
              content: data.error_message,
              color: 'alert',
              autoclose: 3000
            });
            $scope.labels = null;
            $scope.series = null;
            $scope.data = null;

            vm.titles = {};

            vm.table.reload();
            vm.loading = false;

            return;
          }

          vm.date = data.date;
          var series = [];
          var all = [];
          var labels = [];
          var tr_labels = [];

          for (var operator in data.result) {
            series.push(operator);
            var current = [];
            labels = [];
            tr_labels = [];

            for (var title in data.titles) {
              labels.push(data.titles[title]);
              tr_labels.push(data.titles[title]);
              current.push(data.result[operator][data.titles[title]] || '0');
            }

            all.push(current);
          }

          $scope.labels = labels;
          $scope.series = series;
          $scope.data = all;

          var totals = [];
          var grand_total = 0;
          for (var key in data.result) {
            var total = 0;
            for (var hora in data.result[key]) {
              var qty = parseInt(data.result[key][hora]);
              if (typeof totals[hora] === 'undefined') {
                totals[hora] = 0;
              }
              total += qty;
              totals[hora] += qty;
              grand_total += qty;
            }
            data.result[key]['Total'] = total;
          }
          totals['Total'] = grand_total;
          data.result['Total'] = totals;

          data.titles.push(vm.labels.total);
          vm.titles = data.titles;

          gdata = data;

          vm.table.reload();
          vm.loading = false;
        }, function ({ data }) { console.log(data) });
    }

    vm.reload = reload;

    $scope.options = {
      maintainAspectRatio: true,
      responsive: true,
      datasetFill: true,
      bezierCurve: true
    };

    vm.downloadCsv = function () {
      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += vm.current_type.name;
      for (var i in vm.titles) {
        csvContent += ',' + vm.titles[i];
      }
      csvContent += '\n';
      // ,Resposta Recebida em,Resposta
      for (var operator in gdata.result) {
        var arr = [
          operator
        ];
        for (var title in vm.titles) {
          arr.push(gdata.result[operator][vm.titles[title]] || '0');
        }
        csvContent += arr.join(',');
        csvContent += '\n';
      }
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'download-rel.csv');
      document.body.appendChild(link);
      link.click();
    };

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });
  }
})();
